export const ROUTES = {
  HOME: {
    exact: false,
    path: '/home',
    basePath: '',
    noNavbar: false,
    noSideBar: false,
    publicRoute: false
  },
  LOGIN: {
    exact: false,
    path: '/',
    basePath: '',
    noNavbar: true,
    noSideBar: true,
    publicRoute: true
  }
};
